import { default as Form } from '@components/Form'

// ACC namespace for global configs
const ACC = window.ACC || {
    vars: {},
    methods: {
        initializeComponents: () => {
            const componentNodes = Array.from(document.querySelectorAll('[data-component="Form"]')) || []
            componentNodes.forEach(node => {
                let props = node.getAttribute('data-props')
                if (props) props = JSON.parse(props)

                new Form(node, props);
            })
        },
    },
}

// load/initialize complex js-components
document.addEventListener('muiTriggered', () => {
    ACC.methods.initializeComponents()
})
